import { BaseUserResponse, FullUserResponse } from "@/redux/users/types";

export const hasOrganizationRole = (
  user: BaseUserResponse | FullUserResponse,
): user is FullUserResponse => {
  return "organizationRole" in user;
};
